<template>
  <pt-pt-feedback-detail class="pt-pt-feedback-detail__withData"></pt-pt-feedback-detail>
</template>

<script>
import PtPtFeedbackDetail from './index'
export default {
  name: 'pt-pt-feedback-detail__withData',
  components: {
    'pt-pt-feedback-detail': PtPtFeedbackDetail
  }
}
</script>
